import React from "react";
import { Component } from "react";
import { withRouter } from "react-router";
import play from "../images/play.png";
import thumbnail from "../images/bannerBg.png";
import { Player } from "video-react";
import volume from "../images/volume.png";
import Mute from "../images/Mute.svg";
import ShareBtn from "../images/ShareBtn.svg";
import ViewBtn from "../images/ViewBtn.svg";
import BackBtn from '../images/arrowLeft.png'
import ShareModal from "./ShareModal";

// http://techslides.com/demos/sample-videos/small.mp4
// https://www.radiantmediaplayer.com/media/big-buck-bunny-360p.mp4

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playTimer: false,
      isAutoPlay: true,
      isMuted: true,
      url: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/WhatsApp+Video+2021-03-31+at+1.35.43+PM.mp4",
      thumbnail: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Defence+Mania_280x160.jpg",
      showShareModal: false,
      shortUrl: "https://d2sqt6igbl7quy.cloudfront.net/classplus-websites/videos/teachersBiographies/iRise.mp4"
    };
  }

  componentDidMount() {
    const { bannerData } = this.props;

    setTimeout(() => {
      this.setState({ playTimer: true });
    }, 8000);
   
  }


  componentWillReceiveProps(nextProps){
    if(nextProps.bannerData !== this.props.bannerData){
      this.setState({
        url: nextProps.bannerData && nextProps.bannerData.videoUrl,
        thumbnail: nextProps.bannerData && nextProps.bannerData.thumbnailUrl,
        shortUrl:  nextProps.bannerData && nextProps.bannerData.shortUrl,
      })
    }
  }

  toggleMute = () => {
    this.setState({ isMuted: !this.state.isMuted });
  };

  toggleShare = () => {
    this.setState({showShareModal: !this.state.showShareModal})
  }

  render() {
    const { isAutoPlay, isMuted, url, thumbnail, showShareModal, shortUrl } = this.state;
    const { bannerData, isHome } = this.props;
    // console.log(bannerData)
    return (
      <div className="Banner" style={window.innerWidth > 700 ? {backgroundImage: `url(${bannerData && bannerData.heroSectionImage})`}:{backgroundImage: `url(${bannerData && bannerData.thumbnailMobileUrl})`}}>

      <div class="ResponsiveYTPlayer">
       {
         isHome &&
         <Player
          autoPlay={isHome}
          muted={isMuted}
          volume={0}
          loop={false}
          poster={thumbnail}
          src={shortUrl}
        />
       } 
      
      </div>

        
        <div className="Banner__Container">
          {!isHome && <div className="Banner__Container--Back" onClick={() => {this.props.history.push("/")}}><img src={BackBtn} alt=""/> Back</div>}
          <div className="Banner__Container--Head">{bannerData && bannerData.title}</div>
          <div className="Banner__Container--SubHead">{bannerData && bannerData.videoSubtitle}</div>
          <div className="Banner__Container--Para">
            {bannerData && bannerData.description}
          </div>
          
          <div className="Banner__Container--BtnDiv">
            
            <div className="ButtonDiv">
              <button
                className="Banner__Container--BtnDiv__Btn1"
                onClick={() => isHome ? this.props.history.push(`/${bannerData && bannerData.id}`) : this.props.watchVideoNow(url)}>
                <img
                  className="Banner__Container--BtnDiv__Btn1--Icon"
                  src={play}
                  alt=""
                />
                <div className="Banner__Container--BtnDiv__Btn1--Para">
                  {isHome ? 'View Details' : 'Watch Now'}
                </div>
              </button>
              {
                isHome ? ""
                // <button
                //   className="Banner__Container--BtnDiv__Btn2"
                //   onClick={() => {
                //     this.props.history.push(`/${bannerData && bannerData.id}`);
                //   }}>
                //   Detail
                // </button>
              :
              
              <button
                className="Banner__Container--BtnDiv__Btn2"
                onClick={() => {
                  this.toggleShare();
                }}>
                <img src={ShareBtn} aly="" /> Share
              </button>
              }

            </div>

            <img
              className="Banner__Container--BtnDiv__Vol"
              src={isMuted ? Mute : volume}
              alt=""
              onClick={this.toggleMute}
            />

          </div>
          {
            bannerData && bannerData.audio ?
              <div className="Banner__Container--AudioDetails" style={bannerData && bannerData.viewsCount && window.screen.width > 700 ? {paddingBottom: "100px"}: {}}>
                <div className="Banner__Container--AudioDetails__Col">
                  Language: <span className="Banner__Container--AudioDetails__Col--Info">{bannerData && bannerData.audio}</span>
                </div>
                {bannerData && bannerData.subtitle ?
                  <div className="Banner__Container--AudioDetails__Col">
                    Subtitle: <span className="Banner__Container--AudioDetails__Col--Info">{bannerData && bannerData.subtitle}</span>
                  </div>
                  :
                  ""            
                }

              </div> 
            :
            ""
          }


          
          {
            bannerData && bannerData.viewsCount ? 
              <div className="Banner__Container--Stats">
                {bannerData && bannerData.shareCount ? 
                  <div className="Banner__Container--Stats__Col">
                    <div className="Banner__Container--Stats__Col--Count">{bannerData && bannerData.shareCount}</div>
                    <div className="Banner__Container--Stats__Col--Label"><img src={ShareBtn} alt="" />Share</div>
                  </div> 
                  :
                  ""               
                }

                <div className="Banner__Container--Stats__Col">
                  <div className="Banner__Container--Stats__Col--Count">{bannerData && bannerData.viewsCount}</div>
                  <div className="Banner__Container--Stats__Col--Label"><img src={ViewBtn} alt="" />Views</div>
                </div>
            </div>
            :
            ""
          }

          {
            bannerData && bannerData.mediaUrls ?
              <div className="Banner__Container--Media">
                <div className="Banner__Container--Media__Top">Media Coverage</div>
                <div className="Banner__Container--Media__List">
                  {
                    bannerData && bannerData.mediaUrls && bannerData.mediaUrls.map((data, index)=>{
                      return <div className="Banner__Container--Media__List--Image">
                        <img className="Banner__Container--Media__List--Img" src={data.imageUrl} alt="" onClick={()=>{window.open(data.link, '_blank')}} />
                      </div>
                    })
                  } 
                </div>
                
                
              </div>
              :
              ""
          }


        </div>
        {
          showShareModal && <ShareModal id={bannerData && bannerData.id} toggleShare={this.toggleShare} />
        }
      
      </div>
    );
  }
}

export default withRouter(Banner);
